const state = {
  lightbox: '',
  params: {}
};

const mutations = {
  'SET_LIGHTBOX_CONTENTS' (state, page) {
    if (Array.isArray(page)) {
      state.lightbox = page[0];
      state.params = page[1];
    } else {
      state.lightbox = page;
      state.params = {};
    }
  }
};

const actions = {
  showLightBox: ({ commit }, page) => {
    commit('SET_LIGHTBOX_CONTENTS', page);
  },
  hideLightBox: ({ commit }) => {
    commit('SET_LIGHTBOX_CONTENTS', '');
  }
};

const getters = {
  lightbox: state => {
    return state.lightbox;
  },
  lightboxParams: state => {
    return state.params;
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/condition/lightbox.js